import { ControlValueAccessor } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { Component, ElementRef, EventEmitter, Injector, OnDestroy, Output } from '@angular/core';
import { ToasterService } from '@digistore/ds24-ui/toaster';
import { DOCUMENT } from '@angular/common';
import { isPageBuilderDesignMode, isPageBuilderElementVisible } from '../../../misc/pagebuilder';
import { MonitoringService } from '@orderform/widgets';

@Component({
  template: '',
})
export abstract class AbstractMethodComponent implements ControlValueAccessor, OnDestroy {
  static externalResourcesLoaded = new Set<string>();
  protected _paymentDataChanged = new Subject<any>();
  protected _destroy$ = new Subject<void>();
  protected _subscriptionRegisterOnChange: Subscription;
  protected _debugLabel = '';

  @Output() readonly notAvailable = new EventEmitter<void>();

  protected _toaster = this._injector.get(ToasterService);
  protected _element: ElementRef<HTMLElement> = this._injector.get(ElementRef);

  static uniqueInstanceIdGenerator = 0;
  uniqueInstanceId = AbstractMethodComponent.uniqueInstanceIdGenerator++;

  protected _document = this._injector.get(DOCUMENT);
  protected _monitoring = this._injector.get(MonitoringService);

  constructor(protected _injector: Injector) {}

  protected isActive(): boolean {
    const el = this._element.nativeElement;
    return isPageBuilderElementVisible(el);
  }

  protected _hidePaymentMethodWithError(error: Error, origin: string) {
    this.notAvailable.emit();

    if (isPageBuilderDesignMode()) {
      return;
    }

    this._monitoring.trackValidationError(
      'exception:' + error.message,
      'frontend',
      `orderform-payment-method-${origin}`
    );
  }

  registerOnChange(fn: any): void {
    if (this._subscriptionRegisterOnChange) {
      this._subscriptionRegisterOnChange.unsubscribe();
    }
    this._subscriptionRegisterOnChange = this._paymentDataChanged.subscribe(fn);
  }

  registerOnTouched(fn: any): void {}

  writeValue(obj: any): void {}

  ngOnDestroy() {
    if (this._subscriptionRegisterOnChange) {
      this._subscriptionRegisterOnChange.unsubscribe();
    }
  }
}
